import axios from 'axios';
import type { StatusUpdateType } from './types';
import { TourItemContent } from './types';

const bookAppointmentsForTour = async (
  sendStatusUpdatesTo: StatusUpdateType,
  tourId: string,
) => {
  const { data } = await axios.post(
    `/appointments/${tourId}/book_tour_appointments`,
    {
      sendStatusUpdatesTo,
    },
  );

  return data;
};

export default bookAppointmentsForTour;
